// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"afd0a0fe","213":"d061f5f2","370":"ef4bfb14","385":"3fe216de","467":"7de4464f","487":"edcb84ed","505":"87a2d6e5","619":"9ac047ff","787":"f5484289","872":"bc237f18"}[chunkId] + ".chunk.js";
};